import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_doc_preview = _resolveComponent("doc-preview")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.docs.docs, (doc) => {
      return (_openBlock(), _createBlock(_component_doc_preview, {
        key: `doc_${doc.id}`,
        doc: doc
      }, null, 8, ["doc"]))
    }), 128))
  ]))
}